// extracted by mini-css-extract-plugin
export var breedsearchform = "SectionBreedSearch-module--breedsearchform--d26bf";
export var breedsearchinner = "SectionBreedSearch-module--breedsearchinner--42af5";
export var btncontainer = "SectionBreedSearch-module--btncontainer--11e12";
export var filter = "SectionBreedSearch-module--filter--9296d";
export var formcontainer = "SectionBreedSearch-module--formcontainer--e54a3";
export var heading = "SectionBreedSearch-module--heading--5db5a";
export var imagecontainer = "SectionBreedSearch-module--imagecontainer--9514e";
export var select = "SectionBreedSearch-module--select--e6009";